import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/')) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
};

// Vouchers
export const voucherAPI = {
  create: (data) => api.post('/vouchers', data),
  list: (params) => api.get('/vouchers', { params }),
  get: (id) => api.get(`/vouchers/${id}`),
  update: (id, data) => api.put(`/vouchers/${id}`, data),
  approve: (id) => api.put(`/vouchers/${id}/approve`),
  reject: (id, reason) => api.put(`/vouchers/${id}/reject`, { reason }),
  cancel: (id, reason) => api.put(`/vouchers/${id}/cancel`, { reason }),
  uploadBills: (id, files) => api.post(`/vouchers/${id}/bills`, { files }),
  saveSignature: (id, role, signatureData) => api.post(`/vouchers/${id}/signature`, { role, signatureData }),
};

// Categories
export const categoryAPI = {
  list: () => api.get('/categories'),
  budgetStatus: () => api.get('/categories/budget-status'),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  remove: (id) => api.delete(`/categories/${id}`),
};

// Approvals
export const approvalAPI = {
  list: () => api.get('/approvals'),
};

// Advances
export const advanceAPI = {
  create: (data) => api.post('/advances', data),
  list: (params) => api.get('/advances', { params }),
  get: (id) => api.get(`/advances/${id}`),
  approve: (id) => api.put(`/advances/${id}/approve`),
  reject: (id, reason) => api.put(`/advances/${id}/reject`, { reason }),
  settle: (id, data) => api.post(`/advances/${id}/settle`, data),
};

// Employees
export const employeeAPI = {
  list: () => api.get('/employees'),
  create: (data) => api.post('/employees', data),
  update: (id, data) => api.put(`/employees/${id}`, data),
};

// Dashboard
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
};

// PDF
export const pdfAPI = {
  getVoucherPDF: (id) => api.get(`/pdf/voucher/${id}`),
};

// Reports
export const reportAPI = {
  summary: (params) => api.get('/reports/summary', { params }),
  budget: () => api.get('/reports/budget'),
  audit: (params) => api.get('/reports/audit', { params }),
};

export default api;
